/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Nopriordata3Inputs */

const id_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data sebelumnya`)
};

const ms_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data sebelumnya`)
};

const da_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tidligere data`)
};

const de_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine vorherigen Daten`)
};

const en_us2_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prior data`)
};

const es_es2_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos previos`)
};

const es_mx2_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos previos`)
};

const fil_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang naunang data`)
};

const fr_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée antérieure`)
};

const it_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato precedente`)
};

const hu_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs korábbi adat`)
};

const nl_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen eerdere gegevens`)
};

const no_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tidligere data`)
};

const pl_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak poprzednich danych`)
};

const pt_br2_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prior data`)
};

const pt_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados anteriores`)
};

const ro_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără date anterioare`)
};

const fi_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei aiempia tietoja`)
};

const sv_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tidigare data`)
};

const vi_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu trước`)
};

const tr_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki veri yok`)
};

const cs_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná předchozí data`)
};

const bg_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма предишни данни`)
};

const ru_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет предыдущих данных`)
};

const uk_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає попередніх даних`)
};

const ar_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات سابقة`)
};

const hi_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पूर्व डेटा नहीं`)
};

const th_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลก่อนหน้านี้`)
};

const ja_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以前のデータなし`)
};

const zh_cn2_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无先前数据`)
};

const zh_hant1_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prior data`)
};

const ko_components_performancetable_nopriordata3 = /** @type {(inputs: Components_Performancetable_Nopriordata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 데이터 없음`)
};

/**
* | output |
* | --- |
* | "No prior data" |
*
* @param {Components_Performancetable_Nopriordata3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_nopriordata3 = /** @type {((inputs?: Components_Performancetable_Nopriordata3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Nopriordata3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_nopriordata3(inputs)
	if (locale === "ms") return ms_components_performancetable_nopriordata3(inputs)
	if (locale === "da") return da_components_performancetable_nopriordata3(inputs)
	if (locale === "de") return de_components_performancetable_nopriordata3(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_nopriordata3(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_nopriordata3(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_nopriordata3(inputs)
	if (locale === "fil") return fil_components_performancetable_nopriordata3(inputs)
	if (locale === "fr") return fr_components_performancetable_nopriordata3(inputs)
	if (locale === "it") return it_components_performancetable_nopriordata3(inputs)
	if (locale === "hu") return hu_components_performancetable_nopriordata3(inputs)
	if (locale === "nl") return nl_components_performancetable_nopriordata3(inputs)
	if (locale === "no") return no_components_performancetable_nopriordata3(inputs)
	if (locale === "pl") return pl_components_performancetable_nopriordata3(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_nopriordata3(inputs)
	if (locale === "pt") return pt_components_performancetable_nopriordata3(inputs)
	if (locale === "ro") return ro_components_performancetable_nopriordata3(inputs)
	if (locale === "fi") return fi_components_performancetable_nopriordata3(inputs)
	if (locale === "sv") return sv_components_performancetable_nopriordata3(inputs)
	if (locale === "vi") return vi_components_performancetable_nopriordata3(inputs)
	if (locale === "tr") return tr_components_performancetable_nopriordata3(inputs)
	if (locale === "cs") return cs_components_performancetable_nopriordata3(inputs)
	if (locale === "bg") return bg_components_performancetable_nopriordata3(inputs)
	if (locale === "ru") return ru_components_performancetable_nopriordata3(inputs)
	if (locale === "uk") return uk_components_performancetable_nopriordata3(inputs)
	if (locale === "ar") return ar_components_performancetable_nopriordata3(inputs)
	if (locale === "hi") return hi_components_performancetable_nopriordata3(inputs)
	if (locale === "th") return th_components_performancetable_nopriordata3(inputs)
	if (locale === "ja") return ja_components_performancetable_nopriordata3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_nopriordata3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_nopriordata3(inputs)
	return ko_components_performancetable_nopriordata3(inputs)
});
export { components_performancetable_nopriordata3 as "components.performanceTable.noPriorData" }